import {getTimestampCorrelationId} from '../canvas-timeline/canvas_timeline_performance_track';
import DirectApi from '../../../directApi';
import {fetchDataPromises} from '../scheduling_fetch';
import {hasFeatureFlag} from '../../../forecast-app/shared/util/FeatureUtil';
import {getFetchDates} from '../loading/LoadMoreUtil';
import Util from '../../../forecast-app/shared/util/util';

export const fetchData = async (pageComponent, props, companyProjectId, companyProjectGroupId, programPrefix) => {
	let requestUrl = 'scheduling';

	if (props.isProjectTimeline) {
		if (props.programPrefix) {
			requestUrl += `?programPrefix=${props.programPrefix}`;
		} else if (props.groupId) {
			requestUrl += `?companyProjectGroupId=${props.groupId}`;
		} else if (!props.match.params.shareUrl) {
			requestUrl += `?customProjectId=${props.projectId}`;
		} else {
			requestUrl += `?companyProjectId=${props.projectId}`;
		}

		requestUrl += `&timestampCorrelationId=${getTimestampCorrelationId()}`;
	} else {
		requestUrl += `?timestampCorrelationId=${getTimestampCorrelationId()}`;
		requestUrl += `&preventFetchingIdleTimeAllocations=true`;

		if (companyProjectId) {
			requestUrl += `&companyProjectId=${companyProjectId}`;
		} else if (companyProjectGroupId) {
			requestUrl += `&companyProjectGroupId=${companyProjectGroupId}`;
		} else if (programPrefix) {
			requestUrl += `&programPrefix=${programPrefix}`;
		}
	}

	const headers = new Headers();
	headers.append('Content-Type', 'application/json');

	if (props.match.params.shareUrl) {
		headers.append('X-FORECAST-PROJECT-SCHEDULING-SHARE', props.match.params.shareUrl);
	}

	let reqBody = {isProjectTimeline: props.isProjectTimeline};
	if (props.isProjectTimeline && !props.match.params.shareUrl && hasFeatureFlag('incremental_load_more_include_items')) {
		reqBody = {
			...reqBody,
			...getFetchDates(pageComponent),
		};
	}

	const fetchList = [
		{
			url: DirectApi.graphqlServerEndpoint(requestUrl),
			method: 'POST',
			headers,
			credentials: !props.match.params.shareUrl ? 'include' : undefined,
			body: reqBody,
		},
	];

	const {company} = pageComponent.props.viewer;
	const isMixedAllocationModeEnabled = Util.isMixedAllocationModeEnabled(company);

	// If we are showing the project timeline (not in shared view), and we are not showing for a project group, and the project uses task allocations.
	if (props.isProjectTimeline && !isMixedAllocationModeEnabled && !props.match.params.shareUrl && !props.programPrefix) {
		const headers = new Headers();

		headers.append('Content-Type', 'application/json');

		fetchList.push({
			url: DirectApi.graphqlServerEndpoint('scheduling/heatmap?isProjectTimeline=true'),
			method: 'POST',
			headers,
			credentials: 'include',
			body: {
				excludedCompanyProjectId: props.projectId,
				excludedCompanyProjectGroupId: props.groupId,
				excludeIdleTimes: true,
			},
		});
	}

	return fetchDataPromises(fetchList);
};

export const fetchLightWeightData = (props, companyProjectId, companyProjectGroupId) => {
	let requestUrl = 'scheduling/projects/minimal';

	if (props.isProjectTimeline) {
		if (props.groupId) {
			requestUrl += `?companyProjectGroupId=${props.groupId}`;
		} else {
			requestUrl += `?customProjectId=${props.projectId}`;
		}
		requestUrl += `&timestampCorrelationId=${getTimestampCorrelationId()}`;
	} else {
		requestUrl += `?timestampCorrelationId=${getTimestampCorrelationId()}`;
		if (companyProjectId) {
			requestUrl += `&companyProjectId=${companyProjectId}`;
		} else if (companyProjectGroupId) {
			requestUrl += `&companyProjectGroupId=${companyProjectGroupId}`;
		}
	}

	const headers = new Headers();
	if (props.match.params.shareUrl) {
		headers.append('X-FORECAST-PROJECT-SCHEDULING-SHARE', props.match.params.shareUrl);
	}
	const fetchList = [
		{
			url: DirectApi.graphqlServerEndpoint(requestUrl),
			method: 'GET',
			credentials: !props.match.params.shareUrl ? 'include' : undefined,
			headers,
		},
	];

	// If we are showing the project timeline (not in shared view), and we are not showing for a project group, and the project uses task allocations.
	if (!props.match.params.shareUrl && props.isProjectTimeline) {
		const heatmapHeaders = new Headers();
		heatmapHeaders.append('Content-Type', 'application/json');
		fetchList.push({
			url: DirectApi.graphqlServerEndpoint('scheduling/heatmap'),
			headers: heatmapHeaders,
			method: 'POST',
			credentials: !props.match.params.shareUrl ? 'include' : undefined,
			body: {excludedCompanyProjectId: props.projectId, excludeIdleTimes: true},
		});
	}

	return fetchDataPromises(fetchList);
};

export const fetchProgressData = projectId => {
	let requestUrl = 'scheduling/projects/progress';
	if (projectId) {
		requestUrl += '?projectId=' + projectId;
	}

	const headers = new Headers();
	headers.append('Content-Type', 'application/json');

	return DirectApi.Fetch_WithErrorHandling(requestUrl, {
		method: 'GET',
		credentials: 'include',
		headers,
	}).then(response => response.json());
};
